module.exports = __webpack_public_path__ + "img/ESPADA INTEGRAL.dd0fac80.jpg";